import styled from 'styled-components';

export const StyledHighlightSlider = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;
